/**
 * RFC-149: CtaBand — reusable bottom-of-page CTA strip. Caller supplies
 * MarketingCTA buttons.
 */
import type { ReactNode } from 'react';
import { MotionReveal } from './MotionReveal';

interface CtaBandProps {
  title: ReactNode;
  description?: ReactNode;
  ctas: ReactNode;
  footnote?: ReactNode;
  className?: string;
}

export function CtaBand({ title, description, ctas, footnote, className }: CtaBandProps) {
  return (
    <section className={`container mx-auto px-4 py-16 md:py-24 ${className ?? ''}`}>
      <div className="max-w-3xl mx-auto">
        <MotionReveal className="bg-card rounded-3xl p-8 md:p-12 shadow-card border border-border text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">{title}</h2>
          {description ? (
            <p className="text-lg text-muted-foreground mb-8 max-w-xl mx-auto">{description}</p>
          ) : null}
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">{ctas}</div>
          {footnote ? <p className="text-sm text-muted-foreground mt-6">{footnote}</p> : null}
        </MotionReveal>
      </div>
    </section>
  );
}
